import { resolveComponentVariant } from '../componentContract'
import styles from './Primitives.module.css'

const sizes = ['compact', 'default', 'large']

export function Spinner({ label = 'Loading', size = 'default', visibleLabel = false, className = '' }) {
  const resolvedSize = resolveComponentVariant('Spinner size', size, sizes, 'default')
  return (
    <span
      className={[
        styles.spinnerWrap,
        resolvedSize === 'compact' ? styles.spinnerCompact : '',
        resolvedSize === 'large' ? styles.spinnerLarge : '',
        className,
      ].filter(Boolean).join(' ')}
      role="status"
    >
      <span className={styles.spinner} aria-hidden="true" />
      <span className={visibleLabel ? undefined : 'wf-visually-hidden'}>{label}</span>
    </span>
  )
}
